export const tableNameRegex = {
  regex: /^(?=.*[a-zA-Z])[a-zA-Z#@_][a-zA-Z0-9_.]*$/,
};
